import React, {Component, Fragment} from 'react';
import { Link } from 'react-router-dom';
import Pagination from "../../components/Pagination";
import BlogItem from "../../components/Blog/blogItem";
import BlogItemList from "../../components/Blog/blogItemList";


class BlogsContent extends Component {

    constructor(props) {
        super(props);
      
      }

      componentDidMount() {
        
    }

    render() {
        // Change page
        const paginate = currentPage => this.props.blogPaginationSetter({
            currentPage: currentPage
        });
        return (
            <div className={this.props.cols + ' ' + this.props.classes}>
                <Fragment>
                    <div className={`blog-content-wrapper ${this.props.product_type === 'list' && 'blog-list'}`}>
                        <div className="row mtn-30">
                            {
                                this.props.blog_type === 'list' ? (
                                    <div className={'col-12'}>
                                        {
                                            this.props.blogPagination.blogs.map(blog => (
                                                <BlogItemList
                                                    key={blog.contentItemId}
                                                    id={blog.contentItemId}
                                                    thumb={blog.thumb}
                                                    title={blog.displayText}
                                                    excerpt={blog.excerpt}
                                                    postBy={blog.blogAuthor}
                                                    date={blog.publishDate}
                                                />
                                            ))
                                        }
                                    </div>
                                ) : (
                                    this.props.blogPagination.blogs.map(blog => (
                                        <BlogItem
                                            key={blog.contentItemId}
                                            alias={blog.alias.alias}
                                            id={blog.contentItemId}
                                            cols={this.props.cols === 'col-12' ? 'col-md-6 col-lg-4' : 'col-md-6'}
                                            thumb={blog.thumb}
                                            title={blog.displayText}                                           
                                            excerpt={blog.blogOverview.html}
                                            postBy={blog.blogAuthor}
                                            date={blog.blogCreateDate}
                                        />
                                    ))
                                )
                            }
                        </div>
                    </div>
{
    this.props.blogPagination.blogs ? <Pagination
    blogsPerPage={this.props.blogPagination.blogsPerPage}
    totalProducts={this.props.blogPagination.blogs.length}
    paginate={paginate}
    currentPage={this.props.blogPagination.currentPage}
/> : null
}
                    
                </Fragment>
            </div>
        );
    }
}

export default BlogsContent;